import $ from 'jquery';
import Swiper from 'swiper';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/section-half.css';

import '../css/image-block.css';
import '../css/restaurant/restaurant-type.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';

import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';
import '../css/restaurant/restaurant-section.css';
import '../css/restaurant/flip-card.css';
import '../css/restaurant/intro-block.css';
import '../css/restaurant/detail-block.css';
import '../css/contact-block.css';
import '../css/modal-block.css';
import '../css/contact-form.css';
import '../css/success-alert.css';

import urlParser from './urlParser';
import getWordingJson from './request/wordingJson';
import getRestaurantList from './request/restaurantList';
import wordingSetter from './wordingSetter';
import hideLoadingImage from './common/hideLoadingImage';
import renderRestaurantSection from './restaurant/renderRestaurantSection';
import toggleModal from '../js/toggleModal';
import generateEmail from './about/generateEmail';
import validateContactForm from './validateContactForm';
import sendMail from './request/sendMail';
import scrollToAnchor from './scrollToAnchor';

/**
 * in hualien OR kaohsiung, this page is static
 * but it's a dynamic page in xinzhuang OR taoyuan
 */
const staticPage = urlParser.branch === 'hualien' || urlParser.branch === 'kaohsiung';

setup();

getWordingJson('restaurant')
	.then((json) => {
		wordingSetter(json);

		if (staticPage) {
			hideLoadingImage();
		}
	});

/**
 * taoyuan OR xinzhuang branch
 */
if (!staticPage) {
	const restaurantTypeArray = ['restaurant', 'chinese', 'cafe'];
	const banquetTypeArray = ['pavilion', 'wedding', 'meeting'];


	let photoWidth = window.innerWidth - 225;
	if (window.innerWidth <= 768) {
		photoWidth = window.innerWidth;
	}

	const swiperConfig = {
		loop: true,
		effect: 'fade',
		pagination: '.swiper-pagination',
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		speed: 1000,
		width: photoWidth,
	};

	getRestaurantList()
		.then((json) => json.filter(({ restaurant_type: type, photo }) =>
			restaurantTypeArray.concat(banquetTypeArray).includes(type) &&
			photo.length > 0,
		))
		.then((json) => {
			json.filter(({ restaurant_type: type }) => restaurantTypeArray.includes(type))
				.forEach((restaurant, index) => {
					document.querySelector('.restaurant-wrapper.-restaurant')
						.appendChild(
							renderRestaurantSection(restaurant, (index + 1) % 2 === 0),
						);

					Swiper(
						document.querySelector(
							'.restaurant-wrapper.-restaurant > .restaurant-section:last-child > .swiper-container',
						),
						swiperConfig,
					);
				});

			json.filter(({ restaurant_type: type }) => banquetTypeArray.includes(type))
				.forEach((restaurant, index) => {
					document.querySelector('.restaurant-wrapper.-banquet')
						.appendChild(
							renderRestaurantSection(restaurant, (index + 1) % 2 === 0),
						);

					Swiper(
						document.querySelector(
							'.restaurant-wrapper.-banquet > .restaurant-section:last-child > .swiper-container',
						),
						swiperConfig,
					);
				});

			/**
			 * scroll to the specific restaurant id section
			 */
			if (window.location.hash) {
				scrollToAnchor(window.location.hash);
			}
		})
		.then(() => {
			$('.flip-card .button-effect, .flip-card .closebtn').on('click', (e) => {
				const cardFront = $(e.currentTarget).parents('.flip-card').find('.intro-block');
				const cardBack = $(e.currentTarget).parents('.flip-card').find('.detail-block');
				$(cardFront).toggleClass('-show');
				$(cardBack).toggleClass('-show');
			});
		})
		.then(() => {
			hideLoadingImage();
		});

	/**
	 * show the contact us form
	 */
	$('.contact-block').removeClass('-hide');

	document.querySelector('.contact-block > .content > .modal-marker')
		.addEventListener('click', (e) => toggleModal(e.target));

	/**
	 * check contact form is not empty and send email
	 */
	$('.contact-form > .button-effect').on('click', () => {
		if (!validateContactForm()) {
			return;
		}

		const mailContent = {
			name: $('.contact-form > input[name="name"]').val(),
			tel: $('.contact-form > input[name="tel"]').val(),
			email: $('.contact-form > input[name="email"]').val(),
			category: $('.contact-form > .select > select[name="category"]').val(),
			content: $('.contact-form > textarea[name="content"]').val(),
		};

		sendMail(generateEmail(mailContent), () => {
			const $successAlert = $('.contact-form > .success-alert');
			$successAlert.removeClass('-hide');

			setTimeout(() => {
				$successAlert.addClass('-hide');
				$('.contact-form > .item').val('');
				$('.contact-form > .selector > .item').val(0);
				$('.modal-block > .closebtn').trigger('click');
			}, 2000);
		}, (err) => {
			console.error(err);
		});
	});
}



// WEBPACK FOOTER //
// ./src/js/restaurants.js